import { render, staticRenderFns } from "./rentals.vue?vue&type=template&id=cce50006&"
import script from "./rentals.vue?vue&type=script&lang=js&"
export * from "./rentals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports